import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=661c07d3&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=ts&"
export * from "./VideoCard.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=661c07d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c07d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardTitle,VHover,VIcon,VImg})
